<i18n src="@/locales/components/CommentTranslate.json"></i18n>

<template>
	<div class="cbs-comment-with-toggle" v-if="postId">
		<div v-if="!isShowCommentList" @click.stop="() => toggleShowCommentList(true)" class="btn-show-comments cursor-pointer rounded-full h-12 w-12 bg-solid-primary">
			<i class="nucleo nucleo-b-chat-2 text-white"></i>
			<span :class="[{ 'rounded-full total-comments--circle': commentData.total < 100, rounded: commentData.total >= 100 }, 'total-comments bg-solid-red text-center text-white']">
				{{ commentData.total >= 100 ? "+99" : commentData.total }}
			</span>
		</div>

		<PerfectScrollbar v-on="$listeners" ref="vueScrollBar" class="main scroll-area--data-list cbs-comment-with-toggle__main">
			<slot></slot>

			<transition name="slide" mode="out-in" tag="div">
				<div class="comments w-full" v-if="isShowCommentList">
					<div class="flex items-center justify-between px-6 py-4 bg-gray-6">
						<div class="info flex items-center">
							<i class="nucleo nucleo-b-chat"></i>
							<span v-if="commentData.total" class="ml-3 text-solid-gray-1">{{ $t("CommentQuantity", { quantity: commentData.total }) }}</span>
							<span v-else class="ml-3 text-solid-gray-1">{{ $t("HaveNotCommentYet") }}</span>
						</div>
						<i class="nucleo nucleo-c-remove-2 text-2xl cursor-pointer" @click.stop="() => toggleShowCommentList(false)"></i>
					</div>

					<CbsCommentGeneral :limit="limit" :displayMode="displayMode" :commentData="commentData" @sendComment="sendComment" @loadMoreComments="loadMoreComments" />
				</div>
			</transition>
		</PerfectScrollbar>
	</div>
	<PerfectScrollbar v-else v-on="$listeners" ref="vueScrollBar" class="scroll-area--data-list">
		<slot></slot>
	</PerfectScrollbar>
</template>

<script>
import _ from "lodash";
import commentGQL from "@/http/requests/inside/comment_gql";

import CbsCommentGeneral from "@/components/cbs-comment-general/CbsCommentGeneral";

export default {
	inheritAttrs: false,
	name: "CbsCommentWithToggle",
	components: { CbsCommentGeneral },
	props: {
		limit: {
			type: Number,
			default: 5
		},
		model: {
			type: String,
			required: true
		},
		postId: {
			type: Number
		},
		displayMode: {
			type: String,
			validator: prop => ["chat", "post-comments"].includes(prop),
			default: "chat"
		}
	},
	emits: {
		toggleCommentList: {}
	},
	data() {
		return {
			commentData: {
				data: [],
				total: 0,
				has_more_pages: null
			},
			isShowCommentList: false
		};
	},
	watch: {
		isShowCommentList() {
			this.updateScrollBar();
		}
	},
	methods: {
		updateScrollBar() {
			if (this.$refs.vueScrollBar) {
				const containerBody = this.$el.querySelector(".cbs-comment-with-toggle__main");
				_.delay(() => {
					this.$refs.vueScrollBar.$el.scrollTop = containerBody.scrollHeight;
					this.$refs.vueScrollBar.ps.update();
				}, 350);
			}
		},
		async getInitCommentData() {
			try {
				this.commentData = await commentGQL.getComments({
					page: 1,
					model: this.model,
					limit: this.limit,
					post_id: this.postId
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		sendComment(comment, resolve, reject) {
			commentGQL
				.addComment({
					content: comment,
					model: this.model,
					post_id: this.postId
				})
				.then(response => {
					this.commentData = Object.assign(
						{},
						{
							...this.commentData,
							data: [response, ...this.commentData.data],
							total: (this.commentData.total += 1)
						}
					);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		},
		loadMoreComments(commentsPage, commentsLimit, resolve, reject) {
			commentGQL
				.getComments({
					model: this.model,
					page: commentsPage,
					limit: commentsLimit,
					post_id: this.postId
				})
				.then(response => {
					this.commentData = Object.assign(
						{},
						{
							...response,
							data: [...this.commentData.data, ...response.data]
						}
					);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		},
		toggleShowCommentList(val) {
			this.isShowCommentList = val;
		}
	},
	created() {
		if (this.postId) {
			this.getInitCommentData();
		}
	}
};
</script>

<style lang="scss" scoped>
.cbs-comment-with-toggle {
	position: relative;
	height: 100%;

	.btn-show-comments {
		position: absolute;
		right: 1.5rem;
		bottom: 1.5rem;
		z-index: 1200;

		.nucleo-b-chat-2 {
			font-size: 22px;
			position: relative;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		::v-deep .total-comments {
			position: absolute;
			top: 0;
			right: -5px;
			font-size: 10px;
			height: 12px;
			line-height: 12px;

			&.total-comments--circle {
				width: 13px;
				height: 13px;
				line-height: 13px;
			}
		}
	}

	.comments {
		background-color: #fff;

		.cbs-comment-general {
			padding: 0 1.5rem;
		}
	}
}

.slide-enter-active {
	animation: slide-up 0.3s ease-in-out;
}

.slide-leave-active {
	animation: slide-down 0.3s ease-in-out;
}

@keyframes slide-up {
	0% {
		transform: translateY(200%);
	}
	100% {
		transform: translateY(0);
	}
}

@keyframes slide-down {
	0% {
		transform: translateY(0);
	}
	100% {
		transform: translateY(200%);
	}
}
</style>
